var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('v-toolbar',{staticClass:"my-3",attrs:{"flat":"","height":"36"}},[_c('v-toolbar-title',[_vm._v("E-Boekhouden")])],1),_c('e-boekhouden-settings')],1)],1),_c('v-row',[_c('v-col',[_c('api-keys')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }